import React, { useContext, useState } from 'react';
import { Collapse, Table, Row, Col } from 'reactstrap';
import { Line } from 'react-chartjs-2'
import { contextApp } from '../../../../App/contextApp';
import Loading from '../../../../loading/Loading';


const Products = (props) => {
const [collapse, setCollapse] = useState(false);
const { monthsLabel, dataIncidences, texts } = props;
const {mostrador} = dataIncidences;
const toggle = () => setCollapse(!collapse);

const {loading, collapseToSS} = useContext(contextApp);

const getProductosPresentation = () => {
    if (!mostrador?.ProductosPresentation) return
    var out = mostrador.ProductosPresentation;
    if(mostrador.ProductosPresentation){
        if(mostrador.ProductosPresentation.length === 1) {
            out = [mostrador.ProductosPresentation[0]];
        }
    }
    return out;
}

const getProductosSabor = () => {
    if (!mostrador?.ProductosSabor) return
    var out = mostrador.ProductosSabor;
    if(mostrador.ProductosSabor){
        if(mostrador.ProductosSabor.length === 1) {
            out = [mostrador.ProductosSabor[0]];
        }
    }
    return out;
}

const getProductosTemperatura = () => {
    if (!mostrador?.ProductosTemperatura) return
    var out = mostrador.ProductosTemperatura;
    if(mostrador.ProductosTemperatura){
        if(mostrador.ProductosTemperatura.length === 1) {
            out = [mostrador.ProductosTemperatura[0]];
        }
    }
    return out;
}

const getMonthsLabel = () => {
    var out = monthsLabel;
    if(monthsLabel.length === 1) {
        out = ['nulo', monthsLabel[0], 'nulo' ];
    }
    return out;
}

const data = {
    labels: getMonthsLabel(),
    datasets:[{
        label: texts.presentation,
        fill: false,
        lineTension: 0,
        backgroundColor: '#f30c0c',
        borderColor: '#f30c0c',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#f30c0c',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 5,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: '#f30c0c',
        pointHoverBorderColor: '#f30c0c',
        pointHoverBorderWidth: 5,
        pointRadius: 5,
        pointHitRadius: 10,
        data: getProductosPresentation()

    },{
        label: texts.taste,
        fill: false,
        lineTension: 0,
        backgroundColor: '#f30c70',
        borderColor: '#f30c70',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#f30c70',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 5,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: '#f30c70',
        pointHoverBorderColor: '#f30c70',
        pointHoverBorderWidth: 5,
        pointRadius: 5,
        pointHitRadius: 20,
        type: 'line',
        data: getProductosSabor(),
    },{
        label: texts.temperature,
        fill: false,
        lineTension: 0,
        backgroundColor: '#f30cb9',
        borderColor: '#f30cb9',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#f30cb9',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 5,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: '#f30cb9',
        pointHoverBorderColor: '#f30cb9',
        pointHoverBorderWidth: 5,
        pointRadius: 5,
        pointHitRadius: 20,
        type: 'line',
        data: getProductosTemperatura(),
    }


]
}
return (
<div>
    <div className='collapseHeader' onClick={toggle}>  
        <h4 className='emigre-bold text-secondary text-left text-white text-uppercase'>
            <i className="icomoon icon-producto text-white ml-3 p-1"></i> Producto <span><svg height="30" width="30" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className={collapse ? "css-6q0nyr-Svg" : "css-6q0nyr-Svg closed"}><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg></span>
        </h4>
    </div>
    <Collapse isOpen={collapse || collapseToSS}>
    {loading ? (
        <Loading />
        ) : null}
        <Row>
            <Col xs={12} className='text-center'>
                <p className="d-inline mx-3 text-center text-uppercase">Presentación<span className="legend badge-box__product-presentacion ml-2"></span></p>
                <p className="d-inline mx-3 text-center text-uppercase">Sabor<span className="legend badge-box__product-sabor ml-2"></span></p>
                <p className="d-inline mx-3 text-center text-uppercase">Temperatura<span className="legend badge-box__product-temperatura ml-2"></span></p>
                <Line data={data} legend={{display:false}}></Line>
            </Col>

        </Row>
        <Row>
            <Col xs={12}>
                <Table bordered responsive>
                    <thead>
                        <tr>
                            <th scope="row" className="bg-secondary text-uppercase">Producto</th>
                            {monthsLabel && monthsLabel.map((item, index) => {
                                return <th className="text-center bg-secondary" key={index}>{item}</th>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-uppercase">Presentación</td>
                            {getProductosPresentation() && getProductosPresentation().map((item, index) => {
                            return <td className="text-center" key={index}>{item}</td>
                            })}
                        </tr>
                        <tr>
                            <td className="text-uppercase">Sabor</td>
                            {getProductosSabor() && getProductosSabor().map((item, index) => {
                            return <td className="text-center" key={index}>{item}</td>
                            })}
                        </tr>
                        <tr>
                            <td className="text-uppercase">Temperatura</td>
                            {getProductosTemperatura() && getProductosTemperatura().map((item, index) => {
                            return <td className="text-center" key={index}>{item}</td>
                            })}
                        </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>
    </Collapse>
</div>
);
}

export default Products;